var map = {
	"./badge_tick-light.de.html": [
		248,
		248
	],
	"./badge_tick-light.en.html": [
		652,
		652
	],
	"./badge_tick-light.es.html": [
		999,
		999
	],
	"./badge_tick-light.fr.html": [
		263,
		263
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 895;
module.exports = webpackAsyncContext;